import MondayProductsHomepageFirstFoldComponent from "./monday-products-homepage-first-fold-component";
import MondayProductsHomepageFirstFoldConfig from "./monday-products-homepage-first-fold-config";
import MondayProductsHomepageFirstFoldAdvancedConfig from "./monday-products-homepage-first-fold-advanced-config";

export default {
  MondayProductsHomepageFirstFoldComponent,
  MondayProductsHomepageFirstFoldConfig,
  MondayProductsHomepageFirstFoldAdvancedConfig
};
